import { FC, useContext, useEffect, useState } from 'react';

import { useQuery } from '@apollo/client';
import { ITabOption, Tabs } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { LocalizationContext } from 'localization';
import {
  GROUPS_TITLES,
  TGroupsTitlesResponse,
  TOTAL_CLIENTS,
  TTotalClientsResponse,
} from 'schemas';

import s from './Clients.module.scss';
import { ClientsTable } from './ClientsTable';
import { GroupsTable } from './GroupsTable';
import { TClientsPageOpenTab } from './interfaces';

export const Clients: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    data: { permissions },
  } = useContext(AuthContext);

  const [openTab, setOpenTab] = useState<TClientsPageOpenTab>('clients');
  const [contClients, setCountClients] = useState<number>(0);

  const { data: clientsData } = useQuery<TTotalClientsResponse>(TOTAL_CLIENTS, {
    fetchPolicy: 'cache-and-network',
    skip: !permissions?.has('client_browse'),
  });

  useEffect(() => {
    if (!clientsData) return;

    setCountClients(() => clientsData.clients.paginatorInfo.total);
  }, [clientsData]);

  const { data: userGroupsData } = useQuery<TGroupsTitlesResponse>(
    GROUPS_TITLES,
    {
      fetchPolicy: 'cache-and-network',
      skip: !permissions?.has('client_browse'),
    }
  );

  const groups = userGroupsData?.userGroups;
  const totalGroups = groups?.length || 0;

  const radioTabOptions: ITabOption<TClientsPageOpenTab>[] = [
    {
      iconName: 'WorkerIcon',
      title: `${t('clients.total')}`,
      value: 'clients',
      count: contClients,
    },
    {
      iconName: 'GroupIcon',
      title: `${t('groups')}`,
      value: 'groups',
      count: totalGroups,
    },
  ];

  const OpenTabsRadio = (
    <Tabs<TClientsPageOpenTab>
      value={openTab}
      onChange={setOpenTab}
      options={radioTabOptions}
      className={s.openTabRadio}
      itemVariant="row"
    />
  );

  return (
    <div className={s.root}>
      {openTab === 'clients' && (
        <ClientsTable
          OpenTabRadio={OpenTabsRadio}
          setCountClients={setCountClients}
        />
      )}
      {openTab === 'groups' && <GroupsTable OpenTabRadio={OpenTabsRadio} />}
    </div>
  );
};
